<template>
  <div>
    <HeaderGestion/>
    <SubHeaderGestion nombreGestion="Gestión del Diccionario"/>
    <FormDiccionario/>
  </div>
</template>

<script>
import HeaderGestion from '../components/HeaderGestion.vue'
import SubHeaderGestion from '../components/SubHeaderGestion.vue'
import FormDiccionario from '../components/FormDiccionario.vue'
export default {
  components: { HeaderGestion, SubHeaderGestion, FormDiccionario },
  name: 'GestionDicc'
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
</style>
